// extracted by mini-css-extract-plugin
export default {"type_tag":"notices_subscriptions-table_type_tag__U1NVJ"};